import type { PaymentCardOptionModel } from 'autogen/swagger/all';
import { GeneralExceptionError } from 'autogen/translation-keys/trans-website-shared-error';
import toast from 'components/Toast';
import i18next from 'i18next';
import { fetchJSON } from 'modules/helpers/fetch';
import ReactLoadingSpinner from 'modules/loadingSpinner';
import createModal from 'modules/modal';

const fetchModel = (url: string): Promise<PaymentCardOptionModel> => fetchJSON(url);

const openEditPaymentCardModal = (event: React.MouseEvent<HTMLButtonElement>, url?: string): Promise<void> => {
    const target = event.target as HTMLElement;
    const remoteUrl = url || target.getAttribute('data-modal-url');

    const paymentModel = fetchModel(remoteUrl);
    const paymentCardChoiceImport = import(/*  webpackChunkName: "PaymentCardChoice" */ 'components/paymentCards/');

    const modal = createModal();
    modal({
        open: true,
        content: <ReactLoadingSpinner />,
        layout: { customTheme: { width: '640px', height: '450px' } }
    });

    const closeModal = () => {
        modal({ open: false });
    };

    return Promise.all([paymentModel, paymentCardChoiceImport])
        .then(([model, paymentCardChoice]): void => {
            const { PaymentCardChoice } = paymentCardChoice;
            modal({
                open: true,
                content: <PaymentCardChoice {...model} closeModal={closeModal} isModal />,
                layout: { customTheme: { width: '640px', height: '450px', padding: '0 10px 40px' } }
            });
        })
        .catch((err: any) => {
            console.error(err);
            toast.error(i18next.t(GeneralExceptionError));
            modal({ open: false });
        });
};

export default openEditPaymentCardModal;
